import emotionalHealth from './emotional-health.jpg';
import physicalHealth from './physical-health.jpg';
import play from './play.jpg';
import professionalLife from './professional-life.jpg';
import relationships from './relationships.jpg';
import spirituality from './spirituality.jpg';

export default [relationships, emotionalHealth, professionalLife, play, spirituality, physicalHealth];
